import type {
  AuthAdapter, AuthCredentials, CallTransport,
} from "../context/execution-context";
import type { StateStore } from "../context/state-store";
import { hasFreshAccessToken } from "./StudioScreenRenderer.utils.auth";
import { isPlainObject } from "./StudioScreenRenderer.utils.data";

/** Refresh only stale tokens; never apply a refresh after the screen changes. */
export async function refreshStaleSession(
  creds: AuthCredentials | null,
  options: {
    transport: CallTransport;
    auth?: AuthAdapter;
    store: StateStore;
    isCancelled: () => boolean;
  },
): Promise<void> {
  if (
    !creds || hasFreshAccessToken(creds) ||
    typeof creds.refreshToken !== "string" || !creds.refreshToken.trim()
  ) return;

  const refreshRes = await options.transport.call("auth.refreshToken", {
    refreshToken: creds.refreshToken,
  });
  const data = refreshRes.ok ? refreshRes.data : null;
  if (
    options.isCancelled() || !isPlainObject(data) ||
    typeof data.accessToken !== "string" ||
    typeof data.userId !== "string"
  ) return;

  const next: AuthCredentials = {
    userId: data.userId,
    accessToken: data.accessToken,
    ...(typeof data.refreshToken === "string"
      ? { refreshToken: data.refreshToken } : {}),
  };
  options.auth?.write(next);
  options.store.set("session", { ...next });
}